export default "__VITE_ASSET__4903d05a__"